// // src/components/Users.js
// import React, { useState, useEffect, useContext } from 'react';
// import axios from 'axios';
// import '../CSS/AllUsers.css'; // Import the CSS file for styling
// import { Context } from './Context';

// const AllUsers = () => {
//     const {getAllUsersUrl}=useContext(Context)
//   const [users, setUsers] = useState([]);
//   const [search, setSearch] = useState('');

//   useEffect(() => {
//     const fetchUsers = async () => {
//       try {
//         const response = await axios.get(`${getAllUsersUrl}`);
//         setUsers(response.data);
//       } catch (error) {
//         console.error('Error fetching users:', error);
//       }
//     };

//     fetchUsers();
//   }, []);

//   const filteredUsers = users.filter(user =>
//     user.email.toLowerCase().includes(search.toLowerCase())
//   );

//   return (
    
// <div className="users-wrapper">
// <h1 className="users-heading">Users</h1>
// <input
//   type="text"
//   placeholder="Search by Email"
//   value={search}
//   onChange={(e) => setSearch(e.target.value)}
//   className="users-search-input"
// />
// <div className="users-list">
//   {filteredUsers.map((user) => (
//     <div key={user._id} className="user-card">
//       <div className="user-detail">
//         <span className="user-label">Full Name:</span>
//         <span className="user-value">{user.fullName}</span>
//       </div>
//       <div className="user-detail">
//         <span className="user-label">Email:</span>
//         <span className="user-value">{user.email}</span>
//       </div>
//       <div className="user-detail">
//         <span className="user-label">Phone Number:</span>
//         <span className="user-value">{user.phoneNumber}</span>
//       </div>
//       <div className="user-detail">
//         <span className="user-label">Referrer Code:</span>
//         <span className="user-value">{user.referrerCode}</span>
//       </div>
//     </div>
//   ))}
// </div>
// </div>
//   );
// };

// export default AllUsers;





// src/components/Users.jsx
import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Context } from './Context';
import styled from 'styled-components';

const AllUsers = () => {
  const { getAllUsersUrl } = useContext(Context);
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${getAllUsersUrl}`);
        setUsers(response.data);
      } catch (error) {
        console.error('Error fetching users:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [getAllUsersUrl]);

  const filteredUsers = users.filter(user =>
    user.email?.toLowerCase().includes(search.toLowerCase()) ||
    user.fullName?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <PageContainer>
      <HeaderSection>
        <div>
          <h2>All Users</h2>
          <p>Manage and view all registered platform users.</p>
        </div>
        <SearchInput
          type="text"
          placeholder="Search by name or email..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </HeaderSection>

      {loading ? (
        <LoadingState>Loading users...</LoadingState>
      ) : (
        <TableWrapper>
          <Table>
            <thead>
              <tr>
                <th>Full Name</th>
                <th>Email Address</th>
                <th>Phone Number</th>
                <th>Referrer Code</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.length > 0 ? (
                filteredUsers.map((user) => (
                  <tr key={user._id || user.id}>
                    <td>
                      <UserCell>
                        <Avatar>{user.fullName ? user.fullName.charAt(0).toUpperCase() : 'U'}</Avatar>
                        <strong>{user.fullName || 'N/A'}</strong>
                      </UserCell>
                    </td>
                    <td>{user.email || 'N/A'}</td>
                    <td>{user.phoneNumber || 'N/A'}</td>
                    <td>
                      <Badge>{user.referrerCode || 'None'}</Badge>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center', padding: '40px', color: '#64748b' }}>
                    No users found matching your search.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </TableWrapper>
      )}
    </PageContainer>
  );
};

export default AllUsers;

// --- Styled Components ---
const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  font-family: inherit;
`;

const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;

  h2 {
    color: #0f172a;
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0 0 4px 0;
  }

  p {
    color: #64748b;
    font-size: 0.95rem;
    margin: 0;
  }
`;

const SearchInput = styled.input`
  padding: 10px 16px;
  width: 280px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 0.95rem;
  outline: none;
  background-color: #ffffff;
  transition: all 0.2s ease;

  &:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`;

const LoadingState = styled.div`
  text-align: center;
  padding: 48px;
  color: #64748b;
  font-size: 1rem;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
`;

const TableWrapper = styled.div`
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
  overflow-x: auto;
  border: 1px solid #e2e8f0;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 0.95rem;

  th, td {
    padding: 14px 20px;
    border-bottom: 1px solid #f1f5f9;
  }

  th {
    background-color: #f8fafc;
    color: #475569;
    font-weight: 600;
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  tr:hover {
    background-color: #f8fafc;
  }
`;

const UserCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  color: #1e293b;
`;

const Avatar = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #e0f2fe;
  color: #0369a1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.9rem;
`;

const Badge = styled.span`
  display: inline-block;
  background: #f1f5f9;
  color: #475569;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 500;
  font-family: monospace;
`;